import React from 'react';
import { Helmet } from 'react-helmet';
import { Navigate, Outlet, useSearchParams } from 'react-router-dom';

import { TrackingRoute } from 'commons/eventing';
import { View } from 'dashboard/components/View';
import { Redirect } from 'dashboard/containers/App/Redirect';
import Generate, { GENERATE_CONTENT_ROUTE } from 'dashboard/pages/Content/pages/Generate';
import ContentList, { ContentArchivedList } from 'dashboard/pages/ContentList';

import CreateTemplate from './CreateTemplate';
import CreateContent from './components/CreateContent';
import { CONTENT_PATH } from './constants';
import Create from './pages/Create';
import { CREATE_ROUTE } from './pages/Create/constants';
import Name, { NAME_ROUTE } from './pages/Create/pages/Name';
import Snapshot, { SNAPSHOT_ROUTE } from './pages/Create/pages/Snapshot';
import Templates, {
  PREVIEW_TEMPLATES_ROUTE,
  CONTENT_LIST_ROUTE,
  CONTENT_ARCHIVED_ROUTE,
} from './pages/Templates';

const LegacyContentRoute = () => {
  const [searchParams] = useSearchParams();
  const subroute =
    searchParams.get('view') === 'archived' ? CONTENT_ARCHIVED_ROUTE.path : CONTENT_LIST_ROUTE.path;
  return <Navigate to={subroute} replace />;
};

const ContentFlag = () => {
  return <ContentList />;
};

const ContentArchivedFlag = () => {
  return <ContentArchivedList />;
};

export const contentRoutes = [
  {
    path: CREATE_ROUTE.path,
    element: <Create />,
  },
  {
    path: `${CREATE_ROUTE.path}/${NAME_ROUTE.path}`,
    element: <Name />,
  },
  {
    path: `${CREATE_ROUTE.path}/:contentId/${SNAPSHOT_ROUTE.path}`,
    element: <Snapshot />,
  },
  {
    path: GENERATE_CONTENT_ROUTE.path,
    element: <Generate />,
  },
  {
    element: (
      <>
        <Helmet title="Content | Candu" />
        <Outlet />
      </>
    ),
    children: [
      {
        path: '',
        element: <LegacyContentRoute />,
      },
      {
        path: 'template',
        element: <Redirect to={`${CONTENT_PATH}/${PREVIEW_TEMPLATES_ROUTE.path}`} />,
      },
      {
        path: CONTENT_LIST_ROUTE.path,
        element: (
          <View subheader={<CreateContent />} titleLvl1="All Content">
            <TrackingRoute pageName="content.list">
              <ContentFlag />
            </TrackingRoute>
          </View>
        ),
      },
      {
        path: PREVIEW_TEMPLATES_ROUTE.path,
        element: (
          <View subheader={<CreateTemplate />} titleLvl1="Templates">
            <TrackingRoute pageName="content.templates">
              <Templates />
            </TrackingRoute>
          </View>
        ),
      },
      {
        path: CONTENT_ARCHIVED_ROUTE.path,
        element: (
          <View titleLvl1="Archived Content">
            <TrackingRoute pageName="content.archived">
              <ContentArchivedFlag />
            </TrackingRoute>
          </View>
        ),
      },
    ],
  },
];
